var BaseZone = require('./frApiBaseZone'),
    fvChannel = require('glRadio').channel('FV');


var FILL_XREF = {
    white_black_border: 'WHITE_BLACK_BORDER',
    black: 'BLACK',
    white: 'WHITE'
};


module.exports = BaseZone.extend({

    defaults: _.extend( {}, BaseZone.prototype.defaults, {

        fill: null, // leave empty so new notes are created from history
        reasonCodes: null // pass in as array but result will be attributes OF valid ones from the models

    } ),

    constructor: function( attributes ) {

        var attrs = attributes || {};

        /* Fill -- only set if provided and it is valid */
        if ( attrs.fill && Object.keys( FILL_XREF ).indexOf( attrs.fill.toLowerCase().trim() ) > -1 ) {
            attrs.fill = FILL_XREF[attrs.fill];
        }

        /* Reason Codes */

        if ( attrs.reasonCodes && attrs.reasonCodes.length > 0 ) {

            var validAndInvalidCodes = fvChannel.request('reasonCodes').getValidAndInvalidCodesFromUserInput( attrs.reasonCodes );

            if ( validAndInvalidCodes.validCodes.length > 0 ) {

                // We must pass the entire model attributes as the would be passed from the DB, to parse correctly in the shape model
                attrs.reasonCodes = validAndInvalidCodes.validCodes.map( function( vc ) {
                    return vc.toJSON();
                });

            } else {

                attrs.reasonCodes = null; // ( set back to null ) .... if setting the attributes from here directly, can't leave an invalid one ...

            }

            if ( validAndInvalidCodes.invalidCodes.length > 0 ) {
                // TODO: perhaps have a 'warnings' concept in addition to errors --- now just using console.warn
                // -- MAYBE WE STORE FOR REFERENCE
                console.warn( 'Reason codes [' + validAndInvalidCodes.invalidCodes.join(', ') + '] are not active codes in the system' );

            }

        }

        BaseZone.call( this, attrs );

    }


});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/api/zone/frApiRedactionZone.js
 ** module id = 680
 ** module chunks = 0
 **/